var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 33 23.71"}},[_c('path',{attrs:{"d":"m0,0h27.75l5.25,11.85-5.25,11.85H0l5.25-11.85L0,0Z","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }